import {HttpService} from "./HttpService";
import {AxiosResponse} from "axios";

export class InsuranceProviderAuthorizationHttpService {

    static async getByInsuranceProviderId(insuranceProviderId: number): Promise<AxiosResponse<string[]>> {
        return await HttpService.getLuxotticaAxios().get<string[]>(
            `/insuranceProviderAuthorizations/byInsuranceProviderId/${insuranceProviderId}`
        );
    }

    static async getIdsByOperationType(operationType: string): Promise<AxiosResponse<number[]>> {
        return await HttpService.getLuxotticaAxios().get<number[]>(
            `/insuranceProviderAuthorizations/idsByOperationType/${operationType}`
        );
    }
}
